import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './Balance.styles';
import * as CS from './Common.styles';
import { balances } from '@/components/Profile/Business/Balance.constants';
import { Typography } from '@/components/UI/Typography/Typography.styles';

interface BalanceProps {
  id: string;
}

export const Balance = React.forwardRef<HTMLDivElement, BalanceProps>(
  ({ id }, ref) => {
    const { t } = useTranslation();

    return (
      <CS.Box id={id} ref={ref}>
        <Typography.Header $variant="2">
          {t('pages.cabinet.private_account')}
        </Typography.Header>
        <S.Subtitle>{t('pages.cabinet.sum_of_all_balances')}</S.Subtitle>

        <S.Price>3000 AZN</S.Price>

        <S.AddBalanceButton appearance="secondary" isFullWidth>
          {t('common.add_balance')}
        </S.AddBalanceButton>

        <S.Title $variant="2">{t('pages.cabinet.balance_split')}</S.Title>

        {balances(t).map(balance => (
          <S.Card key={balance.title}>
            <Typography.Body $variant="1">{balance.title}</Typography.Body>
            <S.Subtitle>{balance.subtitle}</S.Subtitle>

            <S.CardPrice>{balance.money} AZN</S.CardPrice>
          </S.Card>
        ))}
      </CS.Box>
    );
  }
);

Balance.displayName = 'Balance';
